import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { get_currencies_select } from "../../../actions/producto";

export const MonedaSelect = ({ ...restProps }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const OnLoad = async () => {
      const data = await get_currencies_select();
      setItems(data);
    };
    OnLoad();
    return () => {
      setItems([]);
    };
  }, []);

  return <Select options={items} {...restProps} />;
};
